export default __webpack_public_path__ + "static/media/left-arrow-button-wood.d799c2df.png";